// User Repository - Repository Pattern
import apiService from '../api.service';

class UserRepository {
  // Get all users
  async getAll(params = {}) {
    return apiService.get('/users', params);
  }

  // Get single user
  async getById(id) {
    return apiService.get(`/users/${id}`);
  }

  // Create user
  async create(data) {
    // Check if there's an image - if so, use FormData
    if (data.image) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });
      return apiService.upload('/users', formData);
    } else {
      // No image, use regular JSON post
      return apiService.post('/users', data);
    }
  }

  // Update user
  async update(id, data) {
    // Check if there's an image - if so, use FormData with special route
    if (data.image) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });
      return apiService.upload(`/users/${id}/update`, formData);
    } else {
      // No image, use regular JSON put
      return apiService.put(`/users/${id}`, data);
    }
  }

  // Delete user
  async delete(id) {
    return apiService.delete(`/users/${id}`);
  }
}

export default new UserRepository();
